import React, {useEffect, useState} from "react";
import {
    Box
} from "@chakra-ui/react";
import {useParams} from "react-router-dom";
import {getData} from "../../../services/api";
import RentalDetails from "../../../components/rental/RentalDetails";

export default function Rental() {

    const { id } = useParams();

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await getData(`/api/rentals/${id}`);
                setData(result.data);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return (
        <Box pt={"80px"}>
            {loading ? (
                <div>Loading...</div>
            ) : error ? (
                <div>Error: {error}</div>
            ) : data ? (
                <RentalDetails data={data}/>
            ) : (
                <div>Inserat wurde nicht gefunden</div>
            )}
        </Box>
);
}
